import fetch from '@/utils/fetch'

// 列表接口
export const afterSaleList = '/aftersales/setting/return/address/list'

// 创建/更新
export function aftersalesSettingReturnAddress (data) {
  return fetch({
    url: '/aftersales/setting/return/address',
    method: 'post',
    data
  })
}

// 获取售后退货地址设置详情
export function aftersalesSettingReturnDddressDetail (data) {
  return fetch({
    url: '/aftersales/setting/return/address/detail',
    method: 'get',
    params: data
  })
}

// 删除售后退货地址设置
export function deleteAftersalesSettingReturnAddress (data) {
  return fetch({
    url: '/aftersales/setting/return/address',
    method: 'delete',
    params: data
  })
}